export default __webpack_public_path__ + "static/media/auqui2.52d368f3.jpg";